import React, {useEffect, useRef, useState} from 'react';
import {NumericFormat} from "react-number-format";
import LineChart from "../../components/chart/LineChart";
import {useShallowPickSelector} from "../../redux";
import axios from "axios";
import {baseUrl} from "../../api/network";
import {toast} from "react-toastify";
import toastOptions from "../../data/ToastOptions";
import {useNavigate} from "react-router-dom";
import PayoutDialog from './payout';
import {useDispatch} from "react-redux";
import * as AppStore from "../../redux/app";
import Table from "../../components/affiliate/table";

const createGradient = (ctx) => {
    const gradient = ctx.createLinearGradient(0, 0, 0, 450);
    gradient.addColorStop(0, "rgba(34, 197, 94,0.41)");
    gradient.addColorStop(0.6, "rgba(255, 255, 255, 0)");
    return gradient;
};

const AffiliatePanel = () => {
    const navigate = useNavigate();
    const {tgUser} = useShallowPickSelector('user', ['tgUser'])
    const {mainData} = useShallowPickSelector('app', ['mainData'])
    const [loader, setLoader] = useState(true);
    const [dataValue, setDataValue] = useState({});
    const [data, setData] = useState({});
    const [showPayoutDialog, setShowPayoutDialog] = useState(false);
    const [celebrateLoader, setCelebrateLoader] = useState(false);
    const [celebrateLoader1, setCelebrateLoader1] = useState(false);
    const [chartData, setChartData] = useState(null);
    const dispatch = useDispatch();

    const chartRef = useRef(null);

    useEffect(() => {
        // // Get canvas context and create gradient
        const ctx = chartRef?.current?.getContext("2d")?.chart.ctx;

        if (ctx) {
            const gradient = createGradient(ctx);
            // Update chart data and options
            chartRef.current.data.datasets[0].backgroundColor = gradient;
            chartRef.current.update();
        }
    }, []);

    const plugins = [
        {
            beforeDatasetsDraw(chart) {
                chart.ctx.shadowColor = "rgba(37, 99, 235, 0.14)";
                chart.ctx.shadowBlur = 8;
            },
            afterDatasetsDraw(chart) {
                chart.ctx.shadowColor = "rgba(0, 0, 0, 0)";
                chart.ctx.shadowBlur = 0;
            },
        },
    ];
    const options = {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
            x: {
                drawBorder: false,
                ticks: {
                    color: "white",
                },
                grid: {
                    display: true,
                    drawBorder: false,
                    color: "rgba(34,38,46,1)",
                },
                gridLines: {
                    zeroLineColor: "transparent",
                },
            },
            y: {
                beginAtZero: true,
                border: { dash: [5, 5] },
                grid: {
                    drawTicks: false,
                    color: "rgba(34,38,46,1)",
                },
                gridLines: {
                    zeroLineColor: "transparent",
                },
                ticks: {
                    color: "white",
                    callback(value) {
                        return `${value} `;
                    },
                },
            },
        },

        plugins: {
            legend: {
                position: "top",
                display: false,
            },
            title: {
                display: false,
                text: "Visitor: 2k",
            },
            // tooltip: {
            //   enabled: false,
            // },
        },
        elements: {
            point: {
                radius: [6],
                hoverRadius: 6,
            },
        },
        interaction: {
            intersect: false,
            mode: 'nearest',
            axis: 'x'
        },
    };

    useEffect(() => {
        getDataFn()
    }, []);

    useEffect(() => {
        const tg = window?.Telegram?.WebApp;

        // Show the back button in the TWA
        tg?.BackButton?.show();

        // Handle back button press
        tg?.BackButton?.onClick(() => {
            navigate(-1); // Go back to the previous route
        });

        // Clean up the event listener when the component unmounts
        return () => {
            tg?.BackButton?.hide();
            tg?.BackButton?.offClick();
        };
    }, [navigate]);

    const getDataFn = () => {
        const headers = {
            'Content-Type': 'application/json',
        }

        axios.get(`${baseUrl}/affiliate/chart?user_tg_id=${tgUser?.id}`,{headers})
            .then(response => {
                if (response.data.status === '1') {
                    setDataFn(response.data.items)
                    setData(response.data.items)
                } else {
                    toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 21});
                }
            })
            .catch((err) => {
                toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 22});
            })
    }

    const setDataFn = async (data) => {
        const labelsData = data?.map(item => item?.day).reverse()
        const dataSetsData = data?.map(item => Number(item?.count)).reverse()

        const dataValueData = {
            labels: labelsData,
            datasets: [
                {
                    label: "Clients",
                    data: dataSetsData,
                    borderColor: "#22C55E",
                    pointRadius: 3,
                    pointBorderColor: "#ffffff",
                    pointBackgroundColor: "#22C55E",
                    pointBorderWidth: 0,
                    borderWidth: 2,
                    fill: true,
                    fillColor: "#fff",
                    tension: 0.4,
                },
            ],
        };
        await setDataValue(dataValueData)
        setLoader(false);
        setTimeout(() => {
            // // Get canvas context and create gradient
            const ctx = chartRef?.current?.getContext("2d")?.chart.ctx;

            if (ctx) {
                const gradient = createGradient(ctx);
                // Update chart data and options
                chartRef.current.data.datasets[0].backgroundColor = gradient;
                chartRef.current.update();
            }
        }, 100)
    }


    // const onClaimCommissionPressFn = () => {
    //     if (Number(mainData?.current_commissions) > 0) {
    //         setCelebrateLoader1(true)
    //         const headers = {
    //             'Content-Type': 'application/json',
    //         }
    //
    //         axios.get(`${baseUrl}/affiliate/claim/commissions?user_tg_id=${tgUser?.id}`,{headers})
    //             .then(response => {
    //                 if (response.data.status === '1') {
    //                     dispatch(AppStore.getPointsDataFn())
    //                     dispatch(AppStore.actions.setShowCelebrate(true))
    //                     setCelebrateLoader1(false)
    //                 } else {
    //                     setCelebrateLoader1(false)
    //                     toast.error('Something went wrong. Please try again.', toastOptions);
    //                 }
    //             })
    //             .catch(() => {
    //                 setCelebrateLoader1(false)
    //                 toast.error('Something went wrong. Please try again.', toastOptions);
    //             })
    //     }
    // }

    const setOpenFn = () => {
        setShowPayoutDialog(false);
    }

    // const celebrate = () => {
    //     if (Number(mainData?.current_points) > 0) {
    //         setCelebrateLoader(true)
    //         const headers = {
    //             'Content-Type': 'application/json',
    //         }
    //
    //         axios.get(`${baseUrl}/points/claim?user_tg_id=${tgUser?.id}`, {headers})
    //             .then(response => {
    //                 if (response.data.status === '1') {
    //                     dispatch(AppStore.getPointsDataFn())
    //                     dispatch(AppStore.actions.setShowCelebrate(true))
    //                     setCelebrateLoader(false)
    //                 } else {
    //                     setCelebrateLoader(false)
    //                     toast.error('Something went wrong. Please try again.', toastOptions);
    //                 }
    //             })
    //             .catch(() => {
    //                 setCelebrateLoader(false)
    //                 toast.error('Something went wrong. Please try again.', toastOptions);
    //             })
    //     }
    // }

    const sendBackDataFn = (value) => {
        setChartData(value)
    }

    return (
        <div className="container column start">
            <div className="affiliatePanel-container">
                <p className="text-white text-center font-bold fs18 mt60">Monitor Your Network</p>
                <p className="text-white text-center fs16">Here, you can track your referrals and monitor your earnings.</p>
                <div className="affiliatePanel-boxesContainer">
                    {/* <div className="affiliatePanel-boxes">
                        <div className="affiliatePanel-insideBoxes">
                            <p className="text-white fs16">Your Commission</p>
                            <div className="left">
                                <NumericFormat
                                    value={mainData?.current_commissions ? `${mainData?.current_commissions}` : 0.00}
                                    thousandSeparator=","
                                    displayType="text"
                                    title={mainData?.current_commissions ? `${mainData?.current_commissions}` : 0.00}
                                    className="fs30 text-white lineNumber1 wUnset"
                                />
                                <p className="text-green fs16 mb5 ml10">USDT</p>
                            </div>
                        </div>
                        <button type="button" className={`button1 mt10 wUnset pointer relative ${Number(mainData?.current_commissions) > 0 ? '' : 'disabledBtn'}`} disabled={Number(mainData?.commission) < 1 || celebrateLoader1} onClick={onClaimCommissionPressFn}>
                            <span className="text-white fs14">Claim Your Commission</span>
                            {celebrateLoader1 && <div className="center loaderInBtn loaderInBtn3">
                                <div className="loader"></div>
                            </div>}
                        </button>
                    </div> */}
                    {/* <div className="affiliatePanel-boxes">
                        <div className="affiliatePanel-insideBoxes">
                            <p className="text-white fs16 lineNumber1">Total Points <span className="text-orange">you can claim</span></p>
                            <div className="left">
                                <NumericFormat
                                    value={mainData?.current_points ? mainData?.current_points : 0}
                                    thousandSeparator=","
                                    displayType="text"
                                    title={mainData?.current_points ? mainData?.current_points : 0}
                                    className="fs30 text-white lineNumber1 wUnset"
                                />
                                <p className="text-orange fs16 mb5 ml10 nowrap">Points</p>
                            </div>
                        </div>
                        <button type="button" className={`button2 mt10 wUnset pointer relative ${Number(mainData?.current_points) > 0 ? '' : 'disabledBtn'}`} disabled={Number(mainData?.current_points) < 1 || celebrateLoader} onClick={celebrate}>
                            <span className="text-white fs14 noDecoration">Claim Your Points</span>
                            {celebrateLoader && <div className="center loaderInBtn loaderInBtn1">
                                <div className="loader"></div>
                            </div>}
                        </button>
                    </div> */}
                </div>
                <p className="text-white fs18 mt60 font-bold">Total Referrals</p>
                <div className="left">
                    <NumericFormat
                        value={chartData?.total_clients ?? '0'}
                        thousandSeparator=","
                        displayType="text"
                        title={chartData?.total_clients ? `${chartData?.total_clients} Clients` : 'No Data'}
                        className="fs50 text-white lineNumber1 wUnset"
                    />
                    <p className="text-orange fs30 mb5 ml10 nowrap">Clients</p>
                </div>
                <div className="mt60 w100">
                    {loader && (
                        <div className="min-h-[100px]">
                            <div className="center"><div className="loader"></div></div>
                        </div>
                    )}
                    {!loader && (
                        <LineChart
                            dataSet={dataValue}
                            option={options}
                            plugins={plugins}
                            refer={chartRef}
                        />
                    )}
                </div>
            </div>
            <Table sendBackData={sendBackDataFn} />
            <div className="h50"></div>
            {/*<PayoutDialog show={showPayoutDialog} setOpenFn={setOpenFn} />*/}
        </div>
    );
}

export default AffiliatePanel;
